import React, { useState, useContext } from 'react';

import { NotificationManager } from 'react-notifications';
import { useNavigate } from 'react-router';

import AccountDropdown from './AccountDropdown';

import LockImg from '../../assets/images/header/lock.svg';
import BurgerMenuIcon from '../../assets/images/header/menu.png';
import settingsImg from '../../assets/images/settings.svg';
import TenantConfig, { getHeaderLogo, getLogoBanner, getTenant } from '../../config';

/** context */
import { UserContext } from '../../context/UserContext';
import { cleanUpSessionData } from '../../helpers/applicationHelp';

/** helpers */
import { sanitizeHtml } from '../../helpers/format';
import { signOut } from '../../service/profile';

/** components */
import AmazonSidebar from '../Amazon/AmazonSidebar';

const Header = ({ breakpoint }) => {
  const { width } = useContext(UserContext);
  const [showDropdown, setShowDropdown] = useState(false);
  const { profile, setProfile } = useContext(UserContext);
  const navigate = useNavigate();

  const headerInfo = {
    logo: getHeaderLogo(),
    logoBanner: getLogoBanner(),
    needHelpMessage: TenantConfig?.header.needHelpMessage,
    subText: TenantConfig?.header?.headerSubText ? TenantConfig?.header?.headerSubText : '',
  };

  const handleLogout = async () => {
    try {
      await signOut();
      setShowDropdown(false);
      setProfile({});
      cleanUpSessionData();
      NotificationManager.success('You have been successfully logged out!', 'Success', 2000);
      navigate('/landing');
    } catch (e) {
      console.log('error =>', e);
    }
  };
  const handleLogoClick = () => {
    if (profile?.email) {
      navigate('/dashboard');
    }
  };

  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handleDashboardClick = () => {
    navigate('/dashboard');
  };

  const toggleDropDown = (e) => {
    e.stopPropagation();
    setShowDropdown(!showDropdown);
  };

  const handleCloseDropdown = () => {
    setShowDropdown(false);
  };

  const toggleAmazonSidebar = () => {
    const sidebarEl = document.getElementsByClassName('amazon-sidebar')[0];
    sidebarEl.classList.toggle('amazon-sidebar--show');
  };

  return (
    <>
      <div
        className={`${
          width >= breakpoint ? 'landing-header' : 'mobile-landing-header'
        } ${getTenant()}`}
      >
        <div className="header-inner d-flex">
          {TenantConfig?.layout.renderSidebar && profile.email && (
            <div className="toggle-menu-button" onClick={toggleAmazonSidebar}>
              <img src={BurgerMenuIcon} alt="burger-menu" />
            </div>
          )}
          <div className="location-img">
            {TenantConfig?.header?.logoBannerLink ? (
              <>
                <img src={headerInfo?.logo} alt="" />
                {TenantConfig?.layout.renderHeaderTitle && width >= breakpoint && (
                  <div className="title-img">
                    <a href={TenantConfig?.header.logoBannerLink}>
                      <img src={headerInfo?.logoBanner} alt="" />
                    </a>
                    <p>{headerInfo?.subText}</p>
                  </div>
                )}
              </>
            ) : (
              <div onClick={() => handleLogoClick()}>
                <img src={headerInfo?.logo} alt="" />
                {TenantConfig?.layout.renderHeaderTitle && width >= breakpoint && (
                  <div className="title-img" onClick={() => handleLogoClick()}>
                    <img src={headerInfo?.logoBanner} alt="" />
                    <p>{headerInfo?.subText}</p>
                  </div>
                )}
              </div>
            )}
          </div>
          {!profile.email ? (
            <>
              {TenantConfig?.layout.renderSignin && (
                <div
                  className="d-flex signin-button"
                  onClick={() => (window.location = '/auth/sign-in?app=/dashboard')}
                >
                  <img src={LockImg} alt="lock" className="lock-icon" />
                  <span>Sign In</span>
                </div>
              )}
              {TenantConfig?.layout.renderContactInfo && (
                <div className="d-flex header-contact">
                  <img src={settingsImg} alt="" />
                  <p>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(headerInfo?.needHelpMessage),
                      }}
                    />
                  </p>
                </div>
              )}
            </>
          ) : (
            <div className="account-avatar">
              <div className="inner-part">
                <div className="d-flex user-info" onClick={(e) => toggleDropDown(e)}>
                  <img src={LockImg} alt="lock" className="lock-icon" />
                  <span>Welcome, {profile.firstName}</span>
                </div>
                {showDropdown && (
                  <AccountDropdown
                    handleDashboardClick={handleDashboardClick}
                    handleProfileClick={handleProfileClick}
                    handleLogout={handleLogout}
                    handleCloseDropdown={handleCloseDropdown}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        {TenantConfig?.layout.renderHeaderTitle && width < breakpoint && (
          <div className="title-img" onClick={() => handleLogoClick()}>
            <img src={headerInfo?.logoBanner} alt="" />
            <p>{headerInfo?.subText}</p>
          </div>
        )}
      </div>
      {TenantConfig?.layout.renderSidebar && profile.email && (
        <AmazonSidebar
          handleDashboardClick={handleDashboardClick}
          handleProfileClick={handleProfileClick}
        />
      )}
    </>
  );
};

export default Header;
